import { combineReducers } from "redux";
import { alertReducer } from "./alertReducer";
import { cartReducer } from "./cartReducer";
import { dashboardReducer } from "./dashboardReducer";
import formulaReducer from "./formulaReducer";
import { orderReducer } from "./orderReducer";
import { patientReducer } from "./patientReducer";
import { practitionerReducer } from "./practitionerReducer";
import { prescriptionReducer } from "./prescriptionReducer";
import { profileReducer } from "./profileReducer";
import { roleReducer } from "./roleReducer";
import { settingsReducers } from "./settingsReducer";
import { subscriptionReducer } from "./subscriptionReducer";
import { acumaticaReducer } from "./acumaticaReducer";

const rootReducer = combineReducers({
  alert: alertReducer,
  role: roleReducer,
  dashboard: dashboardReducer,
  profile: profileReducer,
  patient: patientReducer,
  practitioner: practitionerReducer,
  prescription: prescriptionReducer,
  order: orderReducer,
  cart: cartReducer,
  formula: formulaReducer,
  subscription: subscriptionReducer,
  settings: settingsReducers,
  acumatica: acumaticaReducer,
});
export default rootReducer;
